import { Component, Vue, Prop } from "vue-property-decorator";
import VueScroll from "vuescroll";
import codeMirror from "codemirror";
import "codemirror/lib/codemirror.css";
// 引入mode
import "codemirror/mode/python/python";

@Component({
    components: {
        VueScroll
    }
})
export default class CodeCopyLeft extends Vue {
    @Prop() readonly code!: any;

    private ops = {
        vuescroll: {
            mode: "native"
        },
        scrollPanel: {},
        rail: {},
        bar: {
            onlyShowBarOnScroll: false,
            background: "rgba(0, 0, 0, .4)"
        }
    };
    private editor: any = null;

    mounted() {
        this.editor = codeMirror.fromTextArea(this.$refs.mycode, {
            mode: "python",
            theme: "seti",
            lineNumbers: true,
            readOnly: "nocursor",
            scrollbarStyle: "null"
        });
    }
}

//@ts-ignore
export { default as CodeCopyLeft } from "./index.vue";
